import { useState, useMemo, useContext } from 'react'
import CardHeaderSlotContext from '../../StateManagment/CardHeaderSlot'
import { DashboardCardFooterContext } from '../dashboard/DashboardCard'
import InlineDetailsContext from '../../StateManagment/InlineDetailsContext'
import DeepAnalysisPeriodContext from '../../StateManagment/DeepAnalysisPeriodContext'
import CardPeriodControl from '../dashboard/CardPeriodControl'

/**
 * Page-level shell for a deep-analysis page (redesign): renders the control
 * bar ("Weergave") above the sections and re-provides the card slot contexts
 * so the controls that normally dock into a card gather there as labelled
 * buttons instead of loose icons:
 *
 *  - filter slot (CardHeaderSlotContext.filterSlot): the filter trigger
 *  - options slot (DashboardCardFooterContext): graph-type / colour buttons,
 *    and the page's period control when DeepAnalysisPeriodContext is provided
 *    (AI-CONTEXT: See docs/features/deep-analysis-period.md)
 *
 * InlineDetailsContext doubles as the deep-analysis mode flag — the docking
 * controls (DashboardFilterBar, DashboardCardOptions) read it to switch to
 * their labelled appearance, and CardHeaderInfoPopover uses it to render
 * detail content inline instead of behind an info icon.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The page's section cards.
 */
const DeepAnalysisLayout = ({ children }) => {
    const [footerEl, setFooterEl] = useState(null)
    const [filterSlot, setFilterSlot] = useState(null)
    const pagePeriod = useContext(DeepAnalysisPeriodContext)

    const headerSlots = useMemo(
        () => ({ counterSlot: null, infoSlot: null, filterSlot }),
        [filterSlot]
    )

    return (
        <InlineDetailsContext.Provider value={true}>
            <CardHeaderSlotContext.Provider value={headerSlots}>
                <DashboardCardFooterContext.Provider value={footerEl}>
                    <div className='deep-analysis-controlbar'>
                        <span className='deep-analysis-controlbar-label'>Weergave</span>
                        <span className='deep-analysis-controlbar-slot' ref={setFilterSlot} />
                        <span className='deep-analysis-controlbar-spacer' />
                        <span className='deep-analysis-controlbar-slot' ref={setFooterEl} />
                    </div>
                    {pagePeriod && (
                        <CardPeriodControl value={pagePeriod.periodValue} onChange={pagePeriod.setPeriodValue} />
                    )}
                    {children}
                </DashboardCardFooterContext.Provider>
            </CardHeaderSlotContext.Provider>
        </InlineDetailsContext.Provider>
    )
}

export default DeepAnalysisLayout
